var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "uploader",
    class: [_vm.prefixCls + '-upload']
  }, [(_vm.type === 'click') ? _c('div', [_c('label', [_c('input', {
    ref: "input",
    attrs: {
      "type": "file",
      "name": _vm.name,
      "accept": _vm.accept,
      "id": _vm.uploadId,
      "multiple": _vm.multiple
    },
    on: {
      "change": function($event) {
        _vm.onChange($event)
      }
    }
  }), _vm._v(" "), _vm._t("default", [_c('n3-button', [_c('n3-icon', {
    attrs: {
      "type": "cloud-upload"
    }
  }), _vm._v("\n          " + _vm._s(_vm.getL('click')) + "\n        ")], 1)])], 2), _vm._v(" "), (_vm.showList) ? _c('div', {
    class: [_vm.prefixCls + '-upload-list']
  }, _vm._l((_vm.uploadList), function(file, index) {
    return _c('div', {
      class: [_vm.prefixCls + '-upload-item']
    }, [_c('div', {
      class: [_vm.prefixCls + '-upload-item-info']
    }, [_c('n3-icon', {
      class: [_vm.prefixCls + '-upload-file-icon'],
      attrs: {
        "type": "file-text-o"
      }
    }), _vm._v(" "), _c('span', {
      class: [_vm.prefixCls + '-upload-file-name']
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('n3-icon', {
      class: [_vm.prefixCls + '-upload-del-info'],
      attrs: {
        "type": "times"
      },
      nativeOn: {
        "click": function($event) {
          _vm.delFile(index)
        }
      }
    })], 1), _vm._v(" "), _c('n3-progress', {
      staticStyle: {
        "padding": "0px 4px"
      }
    }, [_c('n3-progressbar', {
      attrs: {
        "type": "success",
        "height": "3px",
        "now": _vm.progress[index]
      }
    })], 1)], 1)
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.type === 'drag') ? _c('div', {
    class: [_vm.prefixCls + '-upload-drag']
  }, [_c('div', {
    class: [_vm.prefixCls + '-upload-drag-container', _vm.dragover && (_vm.prefixCls + '-upload-is-dragover')],
    style: ({
      width: _vm.dragWidth,
      height: _vm.dragHeight
    })
  }, [_c('input', {
    ref: "input",
    attrs: {
      "type": "file",
      "name": _vm.name,
      "id": _vm.uploadId,
      "accept": _vm.accept,
      "multiple": _vm.multiple
    },
    on: {
      "change": function($event) {
        _vm.onChange($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    class: [_vm.prefixCls + '-upload-drag-area'],
    attrs: {
      "for": _vm.uploadId
    }
  }, [_c('n3-icon', {
    class: [_vm.prefixCls + '-upload-drag-icon'],
    attrs: {
      "type": "cloud-upload"
    }
  }), _vm._v(" "), (_vm.advanceDrag) ? _c('span', [_vm._v(_vm._s(_vm.getL('drag')))]) : _vm._e(), _vm._v(" "), (!_vm.advanceDrag) ? _c('span', [_vm._v(_vm._s(_vm.getL('nodrag')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.showList) ? _c('div', {
    class: [_vm.prefixCls + '-upload-list']
  }, _vm._l((_vm.uploadList), function(file, index) {
    return _c('div', {
      class: [_vm.prefixCls + '-upload-item']
    }, [_c('div', {
      class: [_vm.prefixCls + '-upload-item-info']
    }, [_c('n3-icon', {
      class: [_vm.prefixCls + '-upload-file-icon'],
      attrs: {
        "type": "file-text-o"
      }
    }), _vm._v(" "), _c('span', {
      class: [_vm.prefixCls + '-upload-file-name']
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('n3-icon', {
      class: [_vm.prefixCls + '-upload-del-info'],
      attrs: {
        "type": "times"
      },
      nativeOn: {
        "click": function($event) {
          _vm.delFile(index)
        }
      }
    })], 1), _vm._v(" "), _c('n3-progress', {
      staticStyle: {
        "padding": "0px 4px"
      }
    }, [_c('n3-progressbar', {
      attrs: {
        "type": "success",
        "height": "3px",
        "now": _vm.progress[index]
      }
    })], 1)], 1)
  })) : _vm._e()]) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-93540dcc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93540dcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Uploader/n3Uploader.vue
// module id = 648
// module chunks = 0 1